import * as React from "react";
import PropTypes from "prop-types";
import Button from "nx-components/Button";
import Dialog from "nx-components/Dialog";
import GlobalStyleSheet from "nx-components/GlobalStyleSheet";
import Dispatch from "nexia_mobile/flux_like/dispatch";
import LocalSettings from "nexia_mobile/models/local_settings";
import ScrollableDiv from "nx-components/ScrollableDiv";

// Allow server-sent HTML to provide some default styling despite our reset
const CHOICE_CSS_ID = "nexia-js_ChoiceDialog";
const sheet = `
  .${CHOICE_CSS_ID}_unreset i {
    font-style: italic;
  }
  .${CHOICE_CSS_ID}_unreset b {
    font-weight: bold;
  }
`;

const styles = {
  wrapper: {
    width: "80vw",
    maxWidth: "20em",
    maxHeight: "80vh",
    padding: "1em",
  },
  title: {
    fontSize: "1.15em",
    fontWeight: "bold",
    marginBottom: "0.5em",
  },
  buttons: {
    marginTop: "1em",
    textAlign: "center",
  },
};

export default class ChoiceDialog extends React.Component {
  static propTypes = {
    open: PropTypes.bool,
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired, // html
    buttons: PropTypes.arrayOf(
      PropTypes.shape({
        action: PropTypes.oneOf(["href", "dismiss"]).isRequired,
        text: PropTypes.string.isRequired,
        type: PropTypes.string,
        href: PropTypes.string,
      })
    ),
    onDismiss: PropTypes.func.isRequired,
  };

  _handleButtonClick(button) {
    const { title, onDismiss } = this.props;
    if (button.action === "href" && button.href) {
      fetch(button.href, {
        method: button.method || "POST",
        headers: {
          "Content-Type": "application/json",
          "X-MobileId": LocalSettings.getMobileId(),
          "X-ApiKey": LocalSettings.getApiKey(),
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (!data.success) {
            // TODO: extract this into a nice `handleServerError` method which is
            // exported from the same file as the request API, so that you can tweak
            // behavior going in instead of overloading `handleServerError` so hard.
            Dispatch(
              "SHOW_TOAST",
              (data.error && data.error.message) || "An error occurred."
            );
          }
          onDismiss();
        }, onDismiss);
    } else if (button.action === "dismiss") {
      onDismiss();
    } else {
      onDismiss();
      throw new Error(
        `Attempted to perform unknown Choice button action "${button.action}" for choice with title ${title}`
      );
    }
  }

  render() {
    const { open, title, text, buttons, onDismiss } = this.props;

    return (
      <Dialog
        open={open}
        onTapBackground={onDismiss}
        onRequestClose={onDismiss}
      >
        <ScrollableDiv style={styles.wrapper}>
          <GlobalStyleSheet id={CHOICE_CSS_ID} sheet={sheet} />
          <h1 style={styles.title}>{title}</h1>
          <div
            className={`${CHOICE_CSS_ID}_unreset`}
            dangerouslySetInnerHTML={{ __html: text }}
          />
          {buttons && buttons.length > 0 ? (
            <div style={styles.buttons}>
              {buttons.map((button) => (
                <Button
                  key={button.text}
                  onTap={() => this._handleButtonClick(button)}
                  theme={button.type}
                  full
                >
                  {button.text}
                </Button>
              ))}
            </div>
          ) : null}
        </ScrollableDiv>
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Dialogs/ChoiceDialog.jsx